import moment from 'moment';
import { enumValueNormalizer } from '@/helpers/enum_value_normalizer';
export class ReferralLinkModel {
    constructor(payload) {
        Object.assign(this, payload);
    }
    get formattedCreatedAt() {
        const addedAt = new Date(this.createdAt);
        return moment(addedAt).format('LLL');
    }
    get humanizedSalesChannel() {
        return enumValueNormalizer(this.salesChannel);
    }
}
